import styled from 'styled-components';

export const ContactDetailsContainer = styled.div`
    position: relative;

    .details-header-container {
        position: fixed;
        z-index: 6;
        left: 329px;
        top: 50px;

        border-bottom: 20px solid ${(props) => props.theme.LayoutBodyBackgroundTransparent};
        border-top: 20px solid ${(props) => props.theme.LayoutBodyBackgroundTransparent};

        width: calc(100vw - 370px);

        @media screen and (max-height: 920px) {
            position: relative;
            left: 0px;
            top: 0;
            z-index: 0;
            border-bottom: none;
            border-top: none;
        }

        .ant-ribbon {
            font-weight: bold;
            text-transform: uppercase;
            height: 25px;
            line-height: 25px;
            top: -8px;

            .ribbon-content {
                cursor: pointer;
            }
        }

        .ant-page-header {
            height: ${(props) => (props.customer ? 'unset' : '13rem')};
            border-bottom: ${(props) => props.theme.DefaultBorder};
            padding: 0;

            @media screen and (max-width: 1600px) {
                height: ${(props) => (props.customer ? 'unset' : '18.3rem')};
            }

            .ant-page-header-heading {
                padding-left: ${(props) => (props.customer ? '2rem' : '11rem')};
                padding-right: 1rem;
                padding-top: 0.75rem;

                .ant-page-header-heading-title {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;

                    span.name-icon {
                        margin-right: 12px;
                        font-size: 1rem;
                    }

                    .name {
                        font-size: 2rem;
                        line-height: 1.15;
                        padding-right: 1em;
                        cursor: pointer;
                    }
                    .header-history {
                        line-height: 1.1em;
                        font-size: 0.8rem;
                        font-weight: initial !important;
                        cursor: pointer;
                    }
                }
            }

            .ant-page-header-content {
                padding-top: ${(props) => (props.customer ? '0.25rem' : '0.15rem')};

                .header-body-name-container {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;

                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    margin-bottom: 1rem;

                    .name-wrapper {
                        font-size: 1.6rem;
                        line-height: 1.25;
                        text-transform: capitalize;
                        padding-right: 1em;
                        cursor: pointer;

                        h1 {
                            font-size: 1.6rem;
                            margin: 0;
                            font-weight: 600;
                        }
                    }

                    span.name-icon {
                        margin-right: 12px;
                        font-size: 1rem;
                    }

                    .name {
                        font-size: 1.6rem;
                        line-height: 1.15;
                        padding-right: 1em;
                        cursor: pointer;

                        &.name-with-alert {
                            margin-left: 24px;
                        }
                    }
                }

                .header-content {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: flex-start;
                    padding-left: ${(props) => (props.customer ? '0' : '10rem')};
                    padding-right: 0;
                    min-height: ${(props) => (props.customer ? '5.2rem' : '9.5rem')};

                    @media screen and (max-width: 1600px) {
                        min-height: ${(props) => (props.customer ? '5.2rem' : '11rem')};
                    }

                    .header-body {
                        width: 100%;
                        min-height: ${(props) => (props.customer ? 0 : '65px')};
                        padding: ${(props) => (props.customer ? '0 0 1rem 2rem' : '0 1rem')};

                        a {
                            color: ${(props) => props.theme.TextColor};
                        }

                        p {
                            line-height: 1.1em;
                            font-size: 0.9rem;
                            margin: 0;
                            padding: 0;
                        }

                        .header-body-boxes-container {
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;

                            .ant-divider {
                                margin: 0 4px;
                            }

                            &.model-info-line {
                                @media screen and (max-width: 1650px) {
                                    flex-direction: column;
                                    align-items: flex-start;
                                }

                                .header-models-counters {
                                    display: flex;
                                    justify-content: flex-start;
                                    align-items: center;

                                    @media screen and (max-width: 1650px) {
                                        margin-top: 0.25em;

                                        .ant-divider:first-child {
                                            display: none;
                                        }
                                    }
                                }
                            }

                            .header-body-boxes {
                                margin-bottom: 0.15em;
                                margin-right: 0;
                                padding: 0.25em 0.5em;
                                text-transform: uppercase;
                                font-size: 0.9rem;

                                @media screen and (max-width: 1650px) {
                                    padding: 0;
                                }

                                &.header-body-boxes-hoverable {
                                    cursor: pointer;
                                    &:hover {
                                        background-color: ${(props) => props.theme.SelectedBackgroundColor};
                                        color: #000;
                                    }
                                }
                            }
                        }

                        .header-models-notes {
                            .header-models-note {
                                .created-by {
                                    font-size: ${(props) => props.theme.FontSizeSm};
                                    color: ${(props) => props.theme.TextColorMuted};
                                    text-transform: uppercase;
                                }
                            }
                        }
                    }
                }
            }

            .header-footer {
                /* padding-bottom: 6px; */
                border-top: ${(props) => props.theme.DefaultBorder};
                padding: 0 1rem;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .features-container {
                    display: flex;
                    align-items: center;
                    /* occupa lo spazio lasciato libero dalle azioni; min-width consente
                       allo scroller interno di restringersi sotto la larghezza del contenuto */
                    flex: 1 1 auto;
                    min-width: 0;

                    &.features-container-with-actions {
                        padding-right: 1rem;
                        border-right: ${(props) => props.theme.DefaultBorder};
                    }

                    .features-similar-action {
                        flex: 0 0 auto;
                        margin-left: 0.75rem;
                    }
                }
                .icons-container {
                    display: flex;
                    align-items: center;

                    svg {
                        margin: 0 0.5rem;
                    }
                }
            }
        }

        &.no-sidebar {
            left: 80px;
            width: calc(100vw - 104px);

            @media screen and (max-height: 920px) {
                left: 4px;
            }
        }

        &.details-header-container-drawer {
            position: relative;
            left: 0px;
            top: 0;
            z-index: 0;
            border-bottom: none;
            border-top: none;
            width: auto;

            .ant-page-header {
                height: auto;

                .ant-page-header-heading {
                    padding-top: 0.25rem;
                }

                .ant-page-header-content {
                    .header-content {
                        min-height: ${(props) => (props.customer ? '5.2rem' : '11rem')};

                        .header-body {
                            .header-body-boxes-container {
                                &.model-info-line {
                                    flex-direction: column;
                                    align-items: flex-start;
                                    .header-models-counters {
                                        margin-top: 0.25em;

                                        .ant-divider:first-child {
                                            display: none;
                                        }
                                    }
                                }
                                .header-body-boxes {
                                    padding: 0;
                                }
                            }
                        }
                    }
                }
                .header-footer {
                    .features-container {
                    }
                    .icons-container {
                        svg {
                        }
                    }
                }
            }
        }
    }

    .details-content {
        margin-top: ${(props) => (props.customer ? '11rem' : '14rem')};

        @media screen and (max-width: 1600px) {
            margin-top: ${(props) => (props.customer ? '10rem' : '19rem')};
        }

        @media screen and (max-width: 1280px) {
            margin-top: ${(props) => (props.customer ? '11.5rem' : '19rem')};
        }

        @media screen and (max-height: 920px) {
            margin-top: 1.25rem;
        }
    }
`;
